import React, { useState } from 'react';
import { Avatar, Button, Switch, Table, type TableColumnsType } from 'antd';
import { AssetItemDto, FolderMemberGroupDto } from '@api/Api';
import { hashedColor } from '@helpers/hashedColor';
import { useCurrentWorkspace } from '@hooks/workspace';
import { toggleWorkspaceMemberGroupModal } from '@redux/actions/modalAction';
import { useDispatch } from 'react-redux';

function FolderMemberGroupsTable({
  folder,
  list,
  onShareAccess,
  onRevokeAssess
}: {
  folder: AssetItemDto;
  list: FolderMemberGroupDto[];
  onShareAccess: (a: string) => void | Promise<void>;
  onRevokeAssess: (a: string, b: boolean) => void | Promise<void>;
}) {
  const [workspace] = useCurrentWorkspace();
  const dispatch = useDispatch();
  const [switchLoading, setSwitchLoading] = useState<string | false>(false);
  const columns: TableColumnsType<FolderMemberGroupDto> = [
    {
      title: 'Group name',
      dataIndex: 'name',
      key: 'name',
      render: (_, item) => {
        return (
          <Button
            type="text"
            disabled={!workspace.permissions.listMembers}
            onClick={() =>
              dispatch(
                toggleWorkspaceMemberGroupModal({
                  visible: true,
                  workspace,
                  group: item
                })
              )
            }
          >
            <div className="user_record">
              <div className="user_record__avatar">
                <Avatar
                  size={40}
                  shape="square"
                  style={{
                    background: hashedColor(item.id, 'memberGroupAvatar')
                  }}
                >
                  {item.name[0].toUpperCase()}
                </Avatar>
              </div>
              <div className="user_record__info">
                <div className="name">{item.name}</div>
                <div className="email main-body-text main-body-text--tiny main-body-text--dark-gray">
                  {item.membersCount}{' '}
                  {item.membersCount === 1 ? 'member' : 'members'}
                </div>
              </div>
            </div>
          </Button>
        );
      },
      width: 628
    },
    {
      // eslint-disable-next-line react/no-unstable-nested-components
      title: () =>
        folder.isPrivate && <span style={{ float: 'right' }}>Access</span>,
      key: 'access_to_folder',
      dataIndex: 'access_to_folder',
      render: (_, item) => {
        const isSwitcherDisabled = item.hasAccessToPrivate
          ? !item.permissions.revokeAccess
          : !item.permissions.shareAccess;
        return (
          <div style={{ float: 'right' }}>
            {folder.isPrivate && (
              <>
                <Switch
                  onChange={async () => {
                    setSwitchLoading(item.id);
                    if (!item.hasAccessToPrivate) await onShareAccess(item.id);
                    else await onRevokeAssess(item.id, false);
                    setSwitchLoading(false);
                  }}
                  disabled={isSwitcherDisabled}
                  loading={switchLoading === item.id}
                  checked={item.hasAccessToPrivate}
                />
                <span style={{ marginLeft: 12 }}>
                  {item.hasAccessToPrivate ? 'On' : 'Off'}
                </span>
              </>
            )}
          </div>
        );
      },
      width: 324
    }
  ];
  if (!list.length) return null;
  return (
    <Table
      pagination={false}
      columns={columns}
      dataSource={list}
      rowKey={(node) => node.id}
    />
  );
}

export default FolderMemberGroupsTable;
